import { lazy } from 'react';

const CustomEmpresa = lazy(() => import('./CustomEmpresa'));

export default CustomEmpresa;
